import type { HomeSettings } from "building-types/settings/homeSettings";
import type { SettingsFragment } from "building-types/settings/settingsFragment";
import type { Table } from "common/data/table";
import { mergeSettingsSet } from "doc/mergeSettingsSet";

export function settingsFromLevel(
  levelUniqueId: string,
  homeSettings: HomeSettings,
  settingsTable: Table<SettingsFragment>,
): HomeSettings {
  return mergeSettingsSet(homeSettings, levelUniqueId, settingsTable, true);
}
